(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tjf-deuxunivers"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tjf-univers')) {
  customElements.define('tjf-univers', class extends HTMLElement {
    connectedCallback() {
      this.cleanups = [];
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.querySelectorAll('.tjf-tile').forEach(tile => {
        const slides = [...tile.querySelectorAll('.tjf-slide')];
        if (slides.length < 2) return;
        const dots = [...tile.querySelectorAll('.tjf-dot')];
        const pause = tile.querySelector('.tjf-pause');
        let current = 0, timer, paused = false, hovered = false, focused = false, visible = true;
        const show = i => {
          current = (i + slides.length) % slides.length;
          slides.forEach((slide, n) => slide.classList.toggle('is-active', n === current));
          dots.forEach((dot, n) => { dot.classList.toggle('is-active', n === current); dot.setAttribute('aria-pressed', String(n === current)); });
        };
        const schedule = () => {
          clearInterval(timer);
          if (this.dataset.auto === 'true' && !paused && !hovered && !focused && visible && !document.hidden && !reduced.matches) {
            timer = setInterval(() => show(current + 1), Number(this.dataset.delay) || 5000);
          }
        };
        const listen = (node, event, handler) => { node.addEventListener(event, handler); this.cleanups.push(() => node.removeEventListener(event, handler)); };
        listen(tile.querySelector('.tjf-prev'), 'click', () => { show(current - 1); schedule(); });
        listen(tile.querySelector('.tjf-next'), 'click', () => { show(current + 1); schedule(); });
        dots.forEach((dot, n) => listen(dot, 'click', () => { show(n); schedule(); }));
        if (pause) listen(pause, 'click', () => {
          paused = !paused;
          pause.textContent = paused ? '▶' : 'Ⅱ';
          pause.setAttribute('aria-pressed', String(paused));
          pause.setAttribute('aria-label', paused ? 'Reprendre le défilement' : 'Mettre le défilement en pause');
          schedule();
        });
        listen(tile, 'mouseenter', () => { hovered = true; schedule(); });
        listen(tile, 'mouseleave', () => { hovered = false; schedule(); });
        listen(tile, 'focusin', () => { focused = true; schedule(); });
        listen(tile, 'focusout', event => { focused = tile.contains(event.relatedTarget); schedule(); });
        listen(document, 'visibilitychange', schedule);
        listen(reduced, 'change', schedule);
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); });
          observer.observe(tile);
          this.cleanups.push(() => observer.disconnect());
        }
        this.cleanups.push(() => clearInterval(timer));
        schedule();
      });
    }
    disconnectedCallback() { (this.cleanups || []).forEach(cleanup => cleanup()); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
